module.exports = __webpack_public_path__ + "static/media/UploadSpreadsheets.c22288ce.svg";